import { render } from "./RequestSupportPage.vue?vue&type=template&id=5710b512&ts=true"
import script from "./RequestSupportPage.vue?vue&type=script&lang=ts"
export * from "./RequestSupportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Authentication/RequestSupportPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5710b512"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5710b512', __exports__)) {
    api.reload('5710b512', __exports__)
  }
  
  module.hot.accept("./RequestSupportPage.vue?vue&type=template&id=5710b512&ts=true", () => {
    api.rerender('5710b512', render)
  })

}


export default __exports__